import React from 'react'

export default function Footer() {
    return (
        <div className='bg-dark w-[100vw] p-5 flex justify-center'>
            <p className='text-white text-center'>Designed and Developed by <a className='underline' target='_blank' rel='noreferrer' href="https://github.com/piyush-jaiswal-projects">Piyush Jaiswal</a></p>
        </div>
    )
}